import React, { useState, useEffect, useRef } from "react";
import {
    Row,
    Col,
    Typography,
    Button,
    ProTableOt,
    Form,
    useProTableOt,
    setParamsFilter,
    Select,
    Input

} from "../../ui/ot";
import { useCRUDController } from "../../ui/classify_structure/CRUDController";
import { Upload, FileSpreadsheet, Check, X, AlertCircle, FileText, ArrowRight, TrashIcon } from "lucide-react"
import ExportExcelButton from "../../cataloging/views/export_excel_button";

import dayjs from 'dayjs';

const basicFilterSetting = ["branchcode", "time" ,'itemtype']
const TableCirculationReportDetails = ({
    keyPrefix = "cataloging.serial_receive",
    filterSearchParams = [...basicFilterSetting],
    excelType = null
}) => {
    const [searchParams, setSearchParams] = useState({
        branchcode: null,
        start_time: filterSearchParams.includes("time") ? dayjs().startOf('year').format('YYYY-MM-DD') : null,
        end_time: filterSearchParams.includes("time") ? dayjs().endOf('year').format('YYYY-MM-DD') : null,
    })
    const actionRef = useRef(null);
    const columns = [
        {
            title: "分館代號",
            dataIndex: "branchcode",
            key: "branchcode",
        },
        {
            title: "分館",
            dataIndex: "branchname",
            key: "branchname",
        },
        {
            title: "借閱人次",
            dataIndex: "checkout_users",
            key: "checkout_users",
        },
        {
            title: "借閱冊數",
            dataIndex: "checkout_count",
            key: "checkout_count",
        },
        {
            title: "續借人次",
            dataIndex: "renewal_users",
            key: "renewal_users",
        },
        {
            title: "續借冊數",
            dataIndex: "renewal_count",
            key: "renewal_count",
        },
        {
            title: "預約人次",
            dataIndex: "reserve_users",
            key: "reserve_users",
        },
        {
            title: "預約冊數",
            dataIndex: "reserve_count",
            key: "reserve_count",
        },
    ];
    const TableController = useCRUDController({
        apiRoute: "/koha/report/circulation/detail"
    })
    const libraryController = useCRUDController({ apiRoute: "/koha/library" })
    const itemtypeController = useCRUDController({ apiRoute: "/koha/itemtypes" })

    const { check, setCheck, checkAll, setOrders, custom_filter_key } =
        useProTableOt({
            columns,
        });

    useEffect(() => {
        checkAll();
        libraryController.getData({})
        itemtypeController.getData({})

    }, []);
    useEffect(() => {
        if (!!actionRef.current) {
            actionRef.current.onTableSearch()
        }
    }, [searchParams])

    return (
        <Row
            gutter={[10, 20]}
        >
            <Col span={24}>
                <ProTableOt
                    searchParams={searchParams}
                    rowKey={"id"}
                    actionRef={actionRef}
                    columns={columns}
                    check={check}
                    setCheck={setCheck}
                    // headerTitle={<Typography.Title>{t('')}</Typography.Title>}
                    request={async (params = {}, sort, filter) => {
                        let newParams = {
                            ...searchParams
                        };
                        let order = setOrders(sort);
                        newParams = {
                            ...params,
                            ...newParams,
                            order,
                            size: params.pageSize,
                            cur_page: params.current,
                            custom_filter_value: params.keyword ?? "",
                            custom_filter_key: custom_filter_key,
                        };
                        newParams = setParamsFilter({
                            ...newParams,
                        });

                        return TableController.getData({
                            ...newParams
                        })
                    }}
                    toolBarRender={() => {
                        return [
                            filterSearchParams.includes("time") ? <Col span={24}>
                                <Row gutter={[4, 4]} align={"middle"}>
                                    <Col>
                                        <Typography.P>
                                            日期:
                                        </Typography.P>
                                    </Col>
                                    <Col>
                                        <Input
                                            placeholder={"起"}
                                            type="date"
                                            value={searchParams?.start_time ? searchParams?.start_time : ""}
                                            onChange={(e) => {
                                                setSearchParams((pre) => {
                                                    if (dayjs(e.target.value).isBefore(dayjs(pre?.end_time, "YYYY-MM-DD"))) {
                                                        return {
                                                            ...pre,
                                                            start_time: dayjs(e.target.value).format("YYYY-MM-DD"),
                                                        }
                                                    }
                                                    else {
                                                        return {
                                                            ...pre,
                                                            start_time: pre?.end_time,
                                                            end_time: e.target.value,
                                                        }
                                                    }

                                                })
                                            }}
                                        />
                                    </Col>
                                    <Col>
                                        <Typography.Title level={4}>
                                            ~
                                        </Typography.Title>
                                    </Col>
                                    <Col>
                                        <Input
                                            placeholder={"訖"}
                                            type="date"
                                            value={searchParams?.end_time ? searchParams?.end_time : ""}
                                            onChange={(e) => {
                                                setSearchParams((pre) => {
                                                    if ((dayjs(e.target.value)).isBefore(pre?.start_time)) {
                                                        return {
                                                            ...pre,
                                                            start_time: e.target.value,
                                                            end_time: pre?.start_time,
                                                        }
                                                    }
                                                    else {
                                                        return {
                                                            ...pre,
                                                            end_time: e.target.value,
                                                        }
                                                    }

                                                })
                                            }}
                                        />
                                    </Col>
                                    {(searchParams.start_time || searchParams.end_time) &&
                                        <Col>
                                            <Button
                                                type={"icon"}
                                                onClick={() => {
                                                    setSearchParams((pre) => {
                                                        return {
                                                            ...pre,
                                                            start_time: undefined,
                                                            end_time: undefined
                                                        }
                                                    })
                                                }}>
                                                X
                                            </Button>
                                        </Col>
                                    }
                                </Row>
                            </Col> : <></>,
                            filterSearchParams.includes("branchcode") ? <Col>
                                <Row align={"middle"} gutter={[8, 8]}>
                                    <Col>
                                        分館篩選：
                                    </Col>
                                    <Col>
                                        <Select
                                            allowClear={true}
                                            defaultValue={searchParams?.branchcode}
                                            value={searchParams?.branchcode}
                                            onChange={(value) => {
                                                setSearchParams((pre) => {
                                                    return {
                                                        ...pre,
                                                        branchcode: value
                                                    }
                                                })
                                            }}
                                            options={libraryController?.ResponseData?.map((option) => {
                                                return {
                                                    label: `(${option?.branchcode})${option?.branchname}`,
                                                    value: option?.branchcode,
                                                }
                                            })}
                                        >
                                        </Select>
                                    </Col>
                                </Row>
                            </Col> : <></>,
                            filterSearchParams.includes("itemtype") ? <Col>
                                <Row align={"middle"} gutter={[8, 8]}>
                                    <Col>
                                        館藏分類篩選：
                                    </Col>
                                    <Col>
                                        <Select
                                            allowClear={true}
                                            defaultValue={searchParams?.itemtype}
                                            value={searchParams?.itemtype}
                                            onChange={(value) => {
                                                setSearchParams((pre) => {
                                                    return {
                                                        ...pre,
                                                        item_type: value
                                                    }
                                                })
                                            }}
                                            options={itemtypeController?.ResponseData?.map((option) => {
                                                return {
                                                    label: `(${option?.itemtype})${option?.description}`,
                                                    value: option?.itemtype,
                                                }
                                            })}
                                        >
                                        </Select>
                                    </Col>
                                </Row>
                            </Col> : <></> ,
                            <ExportExcelButton
                                excelType={
                                    excelType}
                                fileName={ "流通統計報表.xlsx"  }
                                params={{
                                    ...searchParams
                                }}
                                apiPath="/koha/report/circulation/excel"
                            />
                        ];
                    }}
                    rowSelection={false}
                    manage_columns={true}

                />
            </Col>
        </Row>
    );
};

export { TableCirculationReportDetails };
